import * as React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

type Props = {
  label: string
  value?: number
  percentage?: number
}

export function StatBlock(props: Props) {
  const { label, value, percentage } = props

  return (
    <Stack ml={3}>
      <Typography variant="subtitle2" color="rgba(0, 0, 0, 0.6)">
        {label ?? <>&mdash;</>}
      </Typography>

      <Stack direction="row" alignItems="center">
        <Typography variant="h6" lineHeight={1}>
          {value ?? <>&mdash;</>}
        </Typography>

        {percentage !== undefined && (
          <Typography variant="subtitle2" ml={0.5} lineHeight={0}>
            {`(${percentage}%)`}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
